import React from "react";
import RouterNavigateOverride from "../components/router-navigate-override";

export default function BasePage({children}){
    return(<RouterNavigateOverride>{children}</RouterNavigateOverride>)
}
